import {Mapper} from '@s-ui/domain'

export default class FromBodyTypeUrlParamToBodyTypeParamsValueObjectMapper extends Mapper {
  constructor({config, valueObject}) {
    super()
    this._config = config
    this._valueObject = valueObject
  }

  map = ({bodyTypeUrlParam: path}) => {
    const {TECHNICAL_DETAILS_BODY_TYPE_PATH_REGEX} = this._config.get('page')
    const matchedParts = path.match(TECHNICAL_DETAILS_BODY_TYPE_PATH_REGEX)
    const {bodyType, doors, year} = matchedParts?.groups || {}

    return this._valueObject({bodyType, year, ...(doors && {doors})})
  }
}
